<template>
    <div
        class="appDownComponent"
        v-if="!$root.$data.isApp && !this.$root.miniprogram "
    >
        <Btn
            title="去启航教育app,领取更多优质好课"
            btnWidth="90%"
            @click.native="goApp"
        />
        <WxShare ref="share"/>
    </div>
</template>
<script>
import WxShare from '@/pages/arkHome/components/wxShre.vue';
import Btn from './btn.vue';

export default {
  components: {
    Btn,
    WxShare,
  },
  methods: {
    goApp() {
      if (this.$root.isWeiXin) {
        this.$refs.share.show = true;
        return;
      }
      const ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) === 'micromessenger') {
        if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
          window.location = 'https://itunes.apple.com/cn/app/id1172161344';
        } else if (navigator.userAgent.match(/android/i)) {
          window.location = 'https://url.cn/5vh6X3Z';
        }
      } else {
        const loadDateTime = Date.now();
        if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
          window.location = 'iqihanglmh5://';
          const turnIOS = setTimeout(() => {
            const timeOutDateTime = Date.now();
            if (timeOutDateTime - loadDateTime < 2200) {
              window.location.href = 'https://itunes.apple.com/cn/app/id1172161344';
            } else {
              clearTimeout(turnIOS);
            }
          }, 2000);
        } else if (navigator.userAgent.match(/android/i)) {
          window.location = 'https://url.cn/5vh6X3Z';
        }
      }
    },
  },
};
</script>
<style scoped lang="scss">
.appDownComponent {
    position: fixed;
    width: 100%;
    bottom: 48px;
}
</style>
